import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import '../style/Header.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Wallet from './Wallet';
import { useModal } from './ModalContext';
import { Link, useLocation } from 'react-router-dom';
import { FaWallet, FaSyncAlt } from 'react-icons/fa';

const Header = () => {
  const [balance, setBalance] = useState(0);
  const { isModalOpen, setIsModalOpen } = useModal();
  const user = auth.currentUser;


  const fetchWalletBalance = async () => {
    try {
      if (!user || !user.uid) {
        toast.error('User not logged in. Please log in (OR) Refresh.');
        return;
      }
      const userRef = doc(db, 'users', user.uid, 'wallet', 'walletDetails');
      const docSnap = await getDoc(userRef);
      if (docSnap.exists()) {
        const userData = docSnap.data();
        setBalance(userData.balance || 0);
      } else {
        setBalance(0);
      }
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
      toast.error('Failed to fetch wallet balance. Please try again.');
    }
  };

  useEffect(() => {
    fetchWalletBalance();
  }, []);

  return (
    <>
      <ToastContainer 
         position="top-right" 
         autoClose={3000} 
         hideProgressBar={false}
         newestOnTop={false}
         closeOnClick
         rtl={false}
         pauseOnFocusLoss={false}
         draggable
         pauseOnHover={false}
         theme="light"
         limit={1}
         enableMultiContainer={false}
         style={{
           zIndex: 9999
         }}
       />

      {/* 
        This Header is now designed to be a part of the main content area,
        sitting to the right of your sidebar.
      */}
      <header className="w-full bg-white p-2">
        {/* The 'justify-end' class pushes all content to the right */}
        <div className="flex justify-end items-center w-full">
            <div className="flex items-center space-x-3 sm:space-x-4 px-4">
                
                {/* Wallet Section */}
                <div className="flex items-center py-2 space-x-3">
                    <FaWallet className="text-blue-500 text-lg" />
                    <span className="font-semibold text-gray-800 text-sm whitespace-nowrap">₹{balance.toFixed(2)}</span>
                    <button 
                        onClick={fetchWalletBalance} 
                        className="text-gray-500 hover:text-gray-800 transition-transform duration-300 hover:rotate-180 bg-white hover:bg-white" 
                        title="Refresh Balance"
                    >
                        <FaSyncAlt />
                    </button>
                </div>

                {/* Recharge Button */}
                <button 
                    onClick={() => setIsModalOpen(true)} 
                    className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-300 text-sm whitespace-nowrap"
                >
                    Recharge
                </button>


<a 
    href="/tickets" 
    className="inline-block px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-300 text-sm whitespace-nowrap text-center no-underline"
>
    Tickets
</a>
            </div>
        </div>
      </header>

      {isModalOpen && <Wallet />}
    </>
  );
};

export default Header;